export default "__VITE_ASSET__Br6P$KYL__"